import { useState, useEffect } from "react";
import { AppConstants, sharedStateKeys } from "../../constants/constant";
import { useFormContext } from "../contexts/FormContext";
import { useSharedStateWithActions } from "./useSharedState";
import { Element } from "../../Interface/scheduler/form";

const useIsMobile = (element?: Element) => {
  const { formValues } = useFormContext();
  const { setValue } = useSharedStateWithActions();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 630);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 630);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //Updating the disclaimer terms to shared state on the following conditions to be
  //displayed on the mobile/desktop above the submit CTA
  useEffect(() => {
    const hideTerms =
      sessionStorage.getItem("countryCode") === AppConstants.COUNTRY_CA;
    if (element?.terms && !formValues.hideOptinTerms && !hideTerms) {
      setValue(sharedStateKeys.DISCLAIMER_TERMS, element.terms);
    }
  }, [element?.terms, formValues.hideOptinTerms]);

  return isMobile;
};

export default useIsMobile;
